export default __webpack_public_path__ + "static/media/device_offline_warning_sound_edited.93bf2161.mp3";